export default __webpack_public_path__ + "images/01c16c876f5c4e99e75d16ff71c6abcf-mailchimp_logo@2x.png";